export const promotionInitialValues = {
  exchangable: "",
  specification: "",
  restrictionsAndDetails: "",
  category: "",
  categories: "",
  dueDate: new Date().toISOString().slice(0, 10),
};
